import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { ACCESS_TOKEN_KEY, getToken, URL } from "./apiHelper";

export const api = axios.create({
  baseURL: URL,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && error.response.status !== 401) {
      throw error;
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {
  const access_token = getToken();
  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  return config;
});

const refreshAuth = (failedRequest) =>
  api
    .post("/auth/refresh", {}, { withCredentials: true, skipAuthRefresh: true })
    .then((tokenRefreshResponse) => {
      const newToken = tokenRefreshResponse.data.access_token;
      localStorage.setItem(ACCESS_TOKEN_KEY, newToken);
      failedRequest.response.config.headers.Authorization =
        "Bearer " + newToken;
      return Promise.resolve();
    })
    .catch((error) => {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      if (window.location.pathname !== "/auth") {
        window.location.replace("/auth");
      }
      return Promise.reject(error);
    });

createAuthRefreshInterceptor(api, refreshAuth);

export default api;
